/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import Header from './Header';
import {bindActionCreators} from 'redux';
import { Segment, Sidebar, Image, Menu, Icon} from 'semantic-ui-react';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as menuActions from '../../actions/menuActions';
import { Auth } from 'aws-amplify';
import * as userActions from '../../actions/userActions';
import * as idiomaActions from '../../actions/idiomaActions'; 
import * as infoActions from '../../actions/infoActions';
import {cargarPagina} from '../../util';


class ManageHeader extends React.Component {
    constructor(props, context) {
		
		super(props, context);
        this.state={ 
		};
	}
    
    

	componentDidMount(){
       
        
	}
    
    signOut=()=>{
        try {
            Auth.signOut();
            this.props.userActions.addUser(null);
            let menu=[];
            
            setTimeout(() => {
                this.props.menuActions.setMenu(menu);
            
            }, 1000);
            
        } catch (error) {
            //console.log('error signing out: ', error);
        }
    }
    
    cambiarIdioma=(page, idioma)=>{
        
        let pageInfo={
                page:page,
                idioma:idioma 
        };
        //console.log("cambiando");
        this.props.infoActions.getInfo(pageInfo).then( (paginaInfo)=>{
                    //console.log(paginaInfo.strings);
                    this.setState({strings: paginaInfo.strings});
                
                  })
            .catch(error=>{
              //toastr.error(error);
            }); 
        
    }
    
    onChange=(e, { name })=> {
         
        this.props.history.push(name);
    }
    
    onChangeIdioma=(event, data)=>{
        let field= data.name;		
        let value = data.value;
        
        this.props.idiomaActions.setIdioma(value);
        cargarPagina(this, value);

        
    }
        
    handleSidebarIzquierdaHide=()=>{
     
    
        this.props.showSidebarIzquierdaActions.onShowSidebarIzquierda(!this.props.showSidebarIzquierda);
    }
    
    render() {
		return (
            <div>
                  
                <Header
                    strings={this.props.strings}
                    onChange={this.onChange}
                    onChangeIdioma={this.onChangeIdioma}
                    user={this.props.user}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    handleSidebarIzquierdaHide={this.handleSidebarIzquierdaHide}
                    showSidebarIzquierda={this.props.showSidebarIzquierda}
                    sidebarIzquierda={this.props.sidebarIzquierda}
                    menu={this.props.menu}
                    signOut={this.signOut}
                    idioma={this.props.idioma}
                    navigate={this.props.navigate}
                />
            
            
            
        
            </div> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){

    return {
       
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        color:state.color,
        sidebarIzquierda:state.sidebarIzquierda,
        menu:state.menu,
        user:state.user,
        strings:state.strings,
        idioma:state.idioma,
        paginaActual:state.paginaActual
    }

}
 
function mapDispatchToProps(dispatch){

	return {  
        userActions: bindActionCreators(userActions, dispatch),
        menuActions: bindActionCreators(menuActions, dispatch),
        idiomaActions: bindActionCreators(idiomaActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),

        };
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageHeader);